/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ServizioMensaStudenteDiscoveryDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListStudentiMensaCittadinoRequestParams {
    gestioneMenseServizioId: string;
}


export interface StudentiCittadinoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista degli studenti del cittadino sul servizio scelto.
     * Header servizio + gate Pratica-accettata. Ritorna i propri studenti sul servizio (DTO leggero: id, nome, cognome, scuola, sospeso, esente). Nessuno studente accessibile → 404.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti
* @param requestParameters
     */
    listStudentiMensaCittadino(requestParameters: ListStudentiMensaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaStudenteDiscoveryDTO>>;

}
